import { MessagePreview } from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { FileTypeIcon } from '../../../common/components/FileTypeIcon/FileTypeIcon.js'

interface Props {
  previewMessage: MessagePreview
}

export const FileAttachmentPreview = ({ previewMessage }: Props) => {
  const { attachmentPreview, imagePreview, embedPreview, preview } =
    previewMessage

  if (!attachmentPreview) {
    return null
  }

  if (preview || embedPreview || imagePreview) {
    return <SvgIcon name="attachment" size="lg" />
  }

  return (
    <div className="flex items-center gap-x-1 truncate">
      <span className="w-[20px] shrink-0">
        <FileTypeIcon
          extension={attachmentPreview.extension}
          className="h-[20px] w-[20px]"
        />
      </span>
      <span className="truncate">{attachmentPreview.name}</span>
    </div>
  )
}
